export const PersonCard = ({ person, onClick, delay = 1 }) => {
  if (!person) return null;

  // A button, not a link: people stories are rendered from a synthesized
  // article object and have no /story/:id of their own to point at. A real
  // <button> still gives keyboard access, Enter/Space activation and the
  // right role to screen readers — which the old <div onClick> gave to
  // nobody. If people stories ever get permanent URLs, this becomes a
  // StoryLink like the article cards.
  return (
    <button
      type="button"
      className={`person-card w-full text-left bg-white border border-scoop-border rounded-md p-4 flex gap-3.5 cursor-pointer fade-in fade-in-${delay} hover:border-scoop-blue focus:outline-none focus-visible:ring-2 focus-visible:ring-scoop-blue focus-visible:ring-offset-2 transition-colors`}
      onClick={onClick}
      data-testid={`person-card-${person.id}`}
    >
      {/* Avatar */}
      <div 
        className="w-12 h-12 rounded-full flex items-center justify-center text-2xl flex-shrink-0"
        style={{ backgroundColor: person.color || "#FFF8EC" }}
      >
        {person.emoji || "👤"}
      </div>
      
      {/* Content */}
      <div>
        <h4 className="font-display font-bold text-sm leading-snug text-scoop-ink mb-1">
          {person.title}
        </h4>
        <p className="text-[0.8rem] text-gray-600 leading-snug">
          {person.description}
        </p>
      </div>
    </button>
  );
};

export default PersonCard;
